import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ModalEjemplo = ({
  mostrarModal,
  cerrarModal,
  volverAtras,
  limpiarResultado,
  habilitarFlujo,
}) => {
  const handleClose = () => {
    volverAtras();
    limpiarResultado();
    habilitarFlujo();
    cerrarModal();
  };

  return (
    <Modal show={mostrarModal} onHide={cerrarModal}>
      <Modal.Header closeButton>
        <Modal.Title>¿Desea editar la fecha?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>El resultado obtenido no sera guardado.</div>
        <Button variant="btn btn-danger" onClick={() => handleClose()}>
          Sí, editar fecha
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default ModalEjemplo;
